import { resolveLocale } from '@/lib/i18n'
import type { Language } from '@repo/constants'
import { atomWithStorage } from 'jotai/utils'
import { store } from '.'

const LOCALE_STORAGE_KEY = 'contractor_locale'

// `null` means "no explicit choice yet", which is what keeps the browser
// language in play. Storing the detected value instead would turn "follow the
// browser" into a one-time snapshot. `getOnInit` keeps `getLocale()`
// synchronous so it can seed i18next's `lng` in __root.tsx.
const localeAtom = atomWithStorage<Language | null>(LOCALE_STORAGE_KEY, null, undefined, {
  getOnInit: true,
})

export const getLocale = (): Language =>
  resolveLocale(
    store.get(localeAtom),
    navigator.languages?.length ? navigator.languages : [navigator.language],
  )

export const setLocale = (locale: Language) => store.set(localeAtom, locale)
